
  export const BRANCHES_RECEIVED = "BRANCHES_RECEIVED";
  export const SET_BRANCH = "SET_BRANCH";
  export const SET_BRANCH_INTERCEPTOR = "SET_BRANCH_INTERCEPTOR";
  export const CREATE_BRANCH = "CREATE_BRANCH";
  export const SET_PROPERTY_BRANCH = "SET_PROPERTY_BRANCH";
  export const SET_INTERCEPTOR = "SET_INTERCEPTOR";
  